import { render, staticRenderFns } from "./Keyboards.vue?vue&type=template&id=565bef44&scoped=true"
import script from "./Keyboards.vue?vue&type=script&lang=js"
export * from "./Keyboards.vue?vue&type=script&lang=js"
import style0 from "./Keyboards.vue?vue&type=style&index=0&id=565bef44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565bef44",
  null
  
)

export default component.exports